import './index.scss'
import React from 'react'
import articlesCollection from './articles'

// 我们的团队
const Collection = (props) => {
  return articlesCollection(props)
}

export default Collection


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/collection/index.js